import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { CampaignType } from "../../../../../../@types/gamification";
import { PrizeTable } from "../../../components/prize-table";
import { type CreateGamificationFormData } from "../../../validations/gamification.validation";

export const StepPrizes: React.FC = () => {
  const form = useFormContext<CreateGamificationFormData>();
  const campaignType =
    useWatch({ control: form.control, name: "campaignType" }) ??
    CampaignType.ROULETTE;

  return (
    <PrizeTable
      campaignType={campaignType}
      control={form.control}
      register={form.register}
      errors={form.formState.errors}
    />
  );
};
